import { Popup } from "@hatch-digital-nl/abs-storybook/legacy";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { JSX } from "react";
import {
    setFormValues,
    setIsRejectCertificateModalOpen,
} from "./RejectCertificateModalSlice";
import { PostActionType, Refetch } from "../../common/types/Types";
import { TextareaFieldComponent } from "./components/TextareaFieldComponent";
import { RejectCertificateModalHeader } from "./components/RejectCertificateModalHeader";
import { SubmitButtonComponent } from "./components/SubmitButtonComponent";
import { FormWrapperComponent } from "./components/FormWrapperComponent";

interface RejectCertificateModalProps {
    refetch: Refetch;
    patchCertificate: PostActionType;
}

export const RejectCertificateModal = (
    props: RejectCertificateModalProps,
): JSX.Element | null => {
    const { refetch, patchCertificate } = props;
    const { isRejectCertificateModalOpen, selectedCertificate } =
        useAppSelector((state) => state.rejectCertificateModal);
    const dispatch = useAppDispatch();

    if (!isRejectCertificateModalOpen || !selectedCertificate) {
        return null;
    }

    return (
        <Popup
            className={"c-reject-certificate-modal"}
            onCloseClick={() => {
                dispatch(setFormValues(null));
                dispatch(setIsRejectCertificateModalOpen(false));
            }}
        >
            <RejectCertificateModalHeader />
            <FormWrapperComponent
                refetch={refetch}
                patchCertificate={patchCertificate}
            >
                <TextareaFieldComponent />
                <SubmitButtonComponent />
            </FormWrapperComponent>
        </Popup>
    );
};
